/**
 * @file  Stock
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React from 'react';
import {Navigation} from '@yunying/crow';
// eslint-disable-next-line import/extensions
import routes from '~/route.config';

import './index.less';


function Stock(props) {
    const {children} = props;

    return (
        <div
            className="stock-container"
            data-content={children}
        >
            <Navigation dataSource={
                routes[0].subRoutes.find(item => item.name === 'stock').subRoutes.map((item, index) => ({
                    title: item.title,
                    key: index,
                    path: `/stock/${item.path}`
                }))
            }
            />
            {children}
        </div>
    );
}

export default Stock;
